import { FirearmStorageLocationResolverBase } from './firearm-storage-location.resolver.base';
import { FirearmStorageLocationService } from './firearm-storage-location.service';
import { Injectable } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class FirearmStorageLocationResolver extends FirearmStorageLocationResolverBase {

  constructor(protected service: FirearmStorageLocationService) {
    super(service);
  }
}



